function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}><path d="M50 100a50 50 0 1 1 50-50 50.058 50.058 0 0 1-50 50zm0-97.486A47.487 47.487 0 1 0 97.488 50 47.54 47.54 0 0 0 50 2.514z" /><rect x="21.5" y="46" width="57" height="8" rx="4" ry="4" /></svg>;
});